var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgImage2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.72 61.82C50.72 64.13 43.23 66 33.99 66C24.76 66 17.27 64.13 17.27 61.82C17.27 59.51 24.76 57.64 33.99 57.64C43.24 57.64 50.72 59.51 50.72 61.82Z",
    fill: "#D0DFFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.98 20.96C52.98 29.87 39.27 45.7 35.16 50.25C34.54 50.93 33.47 50.93 32.85 50.25C28.74 45.7 15.03 29.87 15.03 20.96C15.02 10.48 23.52 2 34 2C44.48 2 52.98 10.48 52.98 20.96Z",
    fill: "#F24865"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.63 20.97C47.63 28.5 41.53 34.6 34 34.6C26.47 34.6 20.36 28.5 20.36 20.97C20.36 13.44 26.47 7.33998 34 7.33998C41.53 7.32998 47.63 13.43 47.63 20.97Z",
    fill: "#CF1B4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.89 20.97C44.89 26.99 40.02 31.86 34 31.86C27.98 31.86 23.1 26.99 23.1 20.97C23.1 14.95 27.98 10.08 34 10.08C40.02 10.08 44.89 14.95 44.89 20.97Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImage2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image2.a8fd6329e156f5a6580253cadfef1ec2.svg";